import React from 'react';
import { SectionCard, TextField, TextAreaField } from '../../../components/admin/EditorFields';

export default function FooterEditor({ data, setData }) {
  const update = (key, value) => setData((d) => ({ ...d, [key]: value }));

  return (
    <div className="space-y-5">
      <SectionCard title="Description de l'association">
        <TextAreaField label="Description (affichée sous le logo dans le footer)" rows={4} value={data.description} onChange={(v) => update('description', v)} />
      </SectionCard>

      <SectionCard title="Newsletter">
        <TextField label="Titre" value={data.newsletterTitle} onChange={(v) => update('newsletterTitle', v)} />
        <TextAreaField label="Description" rows={2} value={data.newsletterDescription} onChange={(v) => update('newsletterDescription', v)} />
      </SectionCard>

      <SectionCard title="Bas du footer">
        <TextField label="Copyright" value={data.copyright} onChange={(v) => update('copyright', v)} hint="Utilisez {year} pour insérer l'année en cours." />
        <TextField label="Mention finale" value={data.designedBy} onChange={(v) => update('designedBy', v)} />
      </SectionCard>
    </div>
  );
}
